export default __webpack_public_path__ + "static/media/referralBanner.6d1ea150.svg";